<template>
  <div>
    <v-col cols="12">
      <h3 class="white--text text-center">Zebra RFID Устройство</h3>
    </v-col>
    <v-col cols="12">
      <base-select
        label="Устройства"
        :items="zebraReaders"
        item-text="friendlyName"
        item-value="bluetoothAddress"
        :readonly="zebraIsConnected"
        v-model="selectedReader"
      ></base-select>
    </v-col>
    <v-col cols="12">
      <v-btn 
        :color="zebraIsConnected ? 'error' : 'success'"
        block
        small
        @click="connectDisconnectButton"
      >
        {{zebraIsConnected ? "Прекъсни връзка" : "Свържи"}}
      </v-btn>
    </v-col>
    <template v-if="zebraIsConnected">
      <v-col cols="12" class="white--text">
        Батерия: {{zebraDeviceInfo.battery.level}}%
      </v-col>
      <v-col cols="12" class="white--text">
        Температура: {{zebraDeviceInfo.temperature.paTemp}} C
      </v-col>
    </template>
  </div>
</template>


<script>
import store from '@/store';
import { mapGetters } from 'vuex'
import { connectZebra, selectZebraConnection } from '@/api/rfid';
export default {
  name: 'VZebraRFID',

  props: {

  },
  data() {
    return {
      selectedReader: '',
      checkReader: {
        interval: 10000,
        repeater: null
      }
    }
  },
  computed: {
    ...mapGetters([
      'zebraIsConnected',
      'zebraReaders',
      'zebraSelectedReader',
      'zebraInventoryState',
      'zebraTagLocateState',
      'zebraPercentageLocate',
      'zebraConfig',
      'zebraDeviceInfo'
    ]),
    
  },
  mounted(){
    this.init();
  },
  methods: {
    init(){
      store.dispatch('zebra/getConnectionStatus').then(response => {
        if(response){
          store.dispatch('zebra/getDeviceInfo');
          store.dispatch('zebra/getInventoryStatus');
          store.dispatch('zebra/getTagLocateStatus');
        }
      })

      if(!this.zebraReaders.length){
        store.dispatch('zebra/getBluetoothReaders').then(response => {
          if(response.length)
            this.selectedReader = response[0].bluetoothAddress;
        })
      }
    },
    connectDisconnectButton(){
      if(this.zebraIsConnected){
        this.disconnect();
      } else {
        this.connect();
      }
    },
    connected(){

    },
    connect(){
      if(this.selectedReader){
        let readerId = 0;
        for(let i=0;i<this.zebraReaders.length;i++){
          if(this.zebraReaders[i].bluetoothAddress === this.selectedReader.bluetoothAddress){
            readerId = i;
            break;
          }
        }

        selectZebraConnection(readerId).then(() => {
          connectZebra().then(response => {
            if(response){
              store.dispatch('zebra/getConnectionStatus')
              store.dispatch('zebra/getDeviceInfoInstant')
              this.$forceUpdate();
            } else {
              this.$snotify.error(null, null, {html: "Моля опитайте отново."});
            }
          })
        })
      } else {
        this.$snotify.error(null, null, {html: "Моля изберете устройство първо."});
      }
    },
    disconnect(){
      store.dispatch('zebra/disconnectReader').then(status => {
        if(!status){
          this.$snotify.success(null, null, {html: "Успешно прекъсване на връзката."});
        } else {
          this.$snotify.error(null, null, {html: "Възникна грешка. Моля опитайте отново."});
        }
      })
    }
  }
}
</script>